import isNil from 'lodash/isNil';
import merge from 'lodash/merge'
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

const withPaymentLogic = (WrappedComponent) => {
	class PaymentLogic extends Component {
		constructor(props) {
			super(props)
			const paymentInfo = props.existing_payments || {}
			this.state = {
				paymentInfo,
				defaultPaymentMethod: paymentInfo.defaultPaymentMethod,
				showStoredPayment: !isNil(props.showStoredPayment) ? props.showStoredPayment : !!paymentInfo.defaultPaymentMethod,
				hasBrowserPay: false,
				hasPaypal: false,
				stripeInfo: paymentInfo.stripe,
				braintreeInfo: paymentInfo.braintree,
				defaultOnly: props.defaultOnly,

			}

			this.state.mountStripe = this.state.defaultOnly ? this.state.defaultPaymentMethod == 'stripe' : true
			this.state.mountPaypal = this.state.defaultOnly ? this.state.defaultPaymentMethod == 'braintree' : true

			this.toggleStoredPayment = this.toggleStoredPayment.bind(this)
			this.updatePaymentInfo = this.updatePaymentInfo.bind(this)
			this.report = this.report.bind(this)
		}

		updatePaymentInfo(paymentInfo) {
			this.setState({
				defaultPaymentMethod: paymentInfo.defaultPaymentMethod,
				stripeInfo: paymentInfo.stripe || {},
				braintreeInfo: paymentInfo.braintree || {},
				isBusy: false,
				errorMessage: '',
				showStoredPayment: true,
			})
		}

		toggleStoredPayment(showStoredPayment) {
			this.setState({ showStoredPayment })
		}

		report(key, value) {
			this.setState({ [key]: value })
		}


		render() {
			const CSRFToken = this.props.csrf_token || this.props.token
			const braintreeToken = this.props.client_token
			const stripePublicKey = this.props.stripe_public_key
			let passedProps = omit(this.props,
				['token', 'csrf_token', 'client_token', 'stripe_public_key'])
			passedProps = merge(passedProps,
				{
					CSRFToken,
					braintreeToken,
					stripePublicKey,
				})

			return (
				<WrappedComponent
					{...passedProps}
					{...this.state}
					toggleStoredPayment={this.toggleStoredPayment}
					report={this.report}
					updatePaymentInfo={this.updatePaymentInfo}
				/>
			)
		}
	}

	return PaymentLogic
}

withPaymentLogic.propTypes = {
	client_token: PropTypes.string.isRequired,
	csrf_token: PropTypes.string.isRequired,
	stripe_public_key: PropTypes.string.isRequired,
	cart: PropTypes.object.isRequired,
	patient: PropTypes.object.isRequired,
	bodyBusy: PropTypes.bool.isRequired,
	setBodyBusy: PropTypes.func.isRequired,
	updateDefaultPaymentMethod: PropTypes.func.isRequired,
	openCrossSell: PropTypes.func,
	hideTitle: PropTypes.bool,
	outline: PropTypes.bool,
	nextStepUrl: PropTypes.string,
	disabled: PropTypes.bool,
	buttonText: PropTypes.string,
	defaultOnly: PropTypes.bool,
	saveOnly: PropTypes.bool,
	darkMode: PropTypes.bool,
	showStoredPayment: PropTypes.bool,
}

export default withPaymentLogic
